export default "__VITE_ASSET__DRk32ixM__"